import {AdminsItemInfos} from "./AdminsItemInfos";


export class StatisticsInfo {

	constructor() {

		 this.allAdmins = null;
		 this.citysCount = -1;
		 this.countryCount = -1;
		 this.keyword = null;
		 this.priorityCitys = null;
		 this.provinceCount = -1;
	}
	
	static GetStatisticsInfo(jsonObj) {
		let statisInfo=null;
		if(jsonObj==null)return statisInfo;
		
		statisInfo=new StatisticsInfo();
		statisInfo.allAdmins= AdminsItemInfos.GetTreeAdminsItems(jsonObj.allAdmins);
		statisInfo.citysCount=jsonObj.citysCount;
		statisInfo.countryCount=jsonObj.countryCount;
		statisInfo.keyword=jsonObj.keyword;
		statisInfo.priorityCitys= AdminsItemInfos.GetAdminsItems(jsonObj.priorityCitys);
		statisInfo.provinceCount=jsonObj.provinceCount;
		return statisInfo;
	}

}//end StatisticsInfo

